import { render, staticRenderFns } from "./ScoringRequestListItem.vue?vue&type=template&id=60537868&scoped=true&lang=pug&"
import script from "./ScoringRequestListItem.vue?vue&type=script&lang=js&"
export * from "./ScoringRequestListItem.vue?vue&type=script&lang=js&"
import style0 from "./ScoringRequestListItem.vue?vue&type=style&index=0&id=60537868&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60537868",
  null
  
)

/* custom blocks */
import block0 from "./ScoringRequestListItem.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports